import { metrics } from './editorCatalog';

const IMG = 'https://static.prod-images.emergentagent.com/jobs/0fd3823c-fd4d-4ea1-83e8-91fa6617f1c3/images/';

export const INTENTS = [
  ['logo', 'Logo erstellen', 'Ich möchte ein Logo erstellen.', `${IMG}3e87bdaadce383759f1ad22ca9fc1860ec1638b5dabb68c768543dca39b2ee88.jpeg`],
  ['illustration', 'Illustration erstellen', 'Ich möchte eine Illustration erstellen.', `${IMG}691138bdc6e5a5f50e35dd768043c3d26a4086a00318c6f1ff576a4bcb9fbc7c.jpeg`],
  ['photo', 'Foto erstellen', 'Ich möchte ein Foto erstellen lassen.', `${IMG}5bc0092094d295039fc6075304ff5f9e0f1f9e698756b5c6d93193ba8817fc9b.jpeg`],
  ['restyle', 'Bild verändern', null, `${IMG}586c82a4635b378bb3381ddb23ba923bdc5023e3eb46991a0b23b975363dcfc8.jpeg`],
];

// Style pickers the assistant can show (question.picker); a tap sends the style as the answer.
export const PICKERS = {
  logo: [
    ['wordmark', 'Wortmarke', `${IMG}9a0d6b78f1d78cedef65d6b40e83fbe05e0724af4d00a42aadbbe13a7de99e51.jpeg`],
    ['emblem', 'Emblem / Badge', `${IMG}f3759dfa8df5b9d16676f168bda6569382b2761a5ed5b7208cbc24fda3ccf09b.jpeg`],
    ['symbol', 'Symbol / Minimal', `${IMG}b66d8746a333cc8108ba5ae4dbdaa48d2f25c2a5e3f483e8f1df3acbfb601b95.jpeg`],
    ['mascot', 'Maskottchen', `${IMG}f33f4fc202fd547320e89c55c0e37fd7685e629407b8f54166b6d804318097b3.jpeg`],
    ['monogram', 'Monogramm', `${IMG}7946e9d5c5b18dfe930a21acf08b1adfeb8794bb23b49962d31929721fee503a.jpeg`],
  ],
  illustration: [
    ['lineart', 'Strichzeichnung', `${IMG}242123b86a6db2cf7233261547e2c4dbeca8b044bf5dc8e211c783c19c6dda10.jpeg`],
    ['silhouette', 'Silhouette', `${IMG}5a86125afda3e4c3e69729732bd16eedd15eba0575c7fc0e73baa85452841203.jpeg`],
    ['watercolor', 'Aquarell', `${IMG}3c8f50c8ea38dbb2df88823a747ca0e9c8cd92b2edb343e1d854bc97a6186a53.jpeg`],
    ['comic', 'Comic', `${IMG}0b3dec99ce636c4716d7c9eda3eaf449715e8b07fd83dfc8337326e0df22117e.jpeg`],
    ['vintage', 'Vintage-Stich', `${IMG}c53858f41e99779c3bc33d41ce0d533a153d1c0efbc73f27473788c785bfdfeb.jpeg`],
  ],
  photo: [
    ['natural', 'Natürlich', `${IMG}f1704210929289265bad8f4360bfa3d8d6e52f4ce97cba24d5d2ef3cc96a51c0.jpeg`],
    ['studio', 'Studio', `${IMG}b0120a652c3d6efad426fa2457177a16ad53f2898a14629388addefc7bc0d099.jpeg`],
    ['bw', 'Schwarz-Weiß', `${IMG}872c643104a0337906381c5b83fd67e85d7e7bdc1e5558ff8dfd30ff3db28fea.jpeg`],
    ['dreamy', 'Verträumt', `${IMG}9dd2da6d0ba20d89f14167171498fd5ded7fbed470f05194e4e87cf93f35b58e.jpeg`],
  ],
};

export const KIND_NAME = { logo: 'KI-Logo', illustration: 'KI-Illustration', photo: 'KI-Foto' };

export const OCCASIONS = [
  ['gift', 'Geschenk', `${IMG}2c4a45c9840ae5b69b17bf47cab752acb042d163fe5e266aaf8a4ddf86bce2a5.jpeg`],
  ['birthday', 'Geburtstag', `${IMG}ca62396f0499f0103bad672261977ff72ef8708e87279c3197c015af0edd6d8b.jpeg`],
  ['wedding', 'Hochzeit', `${IMG}e08d4df7fe3ad1ee13980ef7043f7031039ef5d83e2b0aca5d9c1a1a4bf9805a.jpeg`],
  ['memorial', 'Gedenken', `${IMG}1b8b5b5e11b4356ddd74ba319c3c3249a40b5d052baad774525b9da7f1c742bb.jpeg`],
  ['club', 'Verein', `${IMG}daf2914634e7ba0b9dc498632324bc5b695e6f10ae9dbc823d983845336a514d.jpeg`],
  ['company', 'Firma', `${IMG}bcea09446ab9e4b4fd33045bf47512c03a014938a8c5eefafc5e91af10986c85.jpeg`],
  ['team', 'Team-Event', `${IMG}becb5f0caa76a95499fc19c9bee607bd59255fd40a95522af450cd30aca91249.jpeg`],
  ['fun', 'Just for fun', `${IMG}df28e29e4ed3238cfb87f6f82ebe31eafd5c34c3673fbb791481db9a1eda4145.jpeg`],
];

// Style sets per article group – only what the material can show.
export const STYLE_SETS = {
  textile: [
    ['vintage', 'Vintage', `${IMG}c1b21cf2b9a2f8f15ff1cda9ce2cc2f490074569bac5c381ae1d6b5653fd6cb7.jpeg`],
    ['streetwear', 'Streetwear', `${IMG}3b915b6ba9b44e8bca7cb094e9b915e7383476c449a05310cfc035aaa9fd63d3.jpeg`],
    ['sunset', 'Retro-Sunset', `${IMG}d301a1829ea41f67e5b6a9af5083c04e3c52dd90326e5ba6eaad307f37a860f0.jpeg`],
    ['minimal', 'Minimal', `${IMG}242123b86a6db2cf7233261547e2c4dbeca8b044bf5dc8e211c783c19c6dda10.jpeg`],
    ['comic', 'Comic', `${IMG}e6d3087e6a784ba9647e0af1dadd5cdbc4c8be5049cf1e97c4a46319fa3b9cf1.jpeg`],
    ['corporate', 'Firmen-Clean', `${IMG}0b0f2c516d3c5e39dcb9b1c9dd6f87f9ee6499bf56940b272f2e406dea1e5fba.jpeg`],
    ['sport', 'Sport-Team', `${IMG}c9bcd73d4d0ee1110217aaba65e6df3ba6998ea9ca6586d05abf0c880333b52b.jpeg`],
    ['typo', 'Typo-Statement', `${IMG}19a754e27bdbb686960234e57352aca39ca5a779668e53a44d747c99bb62f194.jpeg`],
  ],
  engraving: [
    ['lineart', 'Strichzeichnung', `${IMG}242123b86a6db2cf7233261547e2c4dbeca8b044bf5dc8e211c783c19c6dda10.jpeg`],
    ['silhouette', 'Silhouette', `${IMG}5a86125afda3e4c3e69729732bd16eedd15eba0575c7fc0e73baa85452841203.jpeg`],
    ['vintage', 'Vintage-Stich', `${IMG}c53858f41e99779c3bc33d41ce0d533a153d1c0efbc73f27473788c785bfdfeb.jpeg`],
    ['mandala', 'Mandala', `${IMG}489712d06bef4c72523ac26c947b988d9585a845029a68252bebbb1e2c04c967.jpeg`],
    ['typo', 'Typografie', `${IMG}2aea607b7ba89fd4637e6b731c757080f2ef510719b929d73d1332f59ac179b4.jpeg`],
    ['emblem', 'Emblem', `${IMG}f3759dfa8df5b9d16676f168bda6569382b2761a5ed5b7208cbc24fda3ccf09b.jpeg`],
  ],
  crystal: [
    ['fineline', 'Fein-Linie', `${IMG}779713255aba163595ff0ad5e17542539caeaa8d0dab4bb24f4dd9c58e39cfa9.jpeg`],
    ['photo', 'Foto-Innengravur', `${IMG}544726c91b3d401d3a39ac552290097bef7a75c4d133f7541527a1563aa9859b.jpeg`],
    ['silhouette', 'Silhouette', `${IMG}5a86125afda3e4c3e69729732bd16eedd15eba0575c7fc0e73baa85452841203.jpeg`],
    ['emblem', 'Emblem', `${IMG}f3759dfa8df5b9d16676f168bda6569382b2761a5ed5b7208cbc24fda3ccf09b.jpeg`],
  ],
};

// Style library set of the article (admin-managed, /api/studio/styles): category + material decide.
export const styleSetOf = editor => {
  if (editor.textile) return 'textile';
  if (metrics.crystal) return 'crystal';
  const p = editor.baseProduct || {}, m = `${p.material || ''} ${p.name || ''}`.toLowerCase();
  if (p.category === 'glas' || /glas|acryl|plexi/.test(m)) return 'glass';
  if (p.category === 'metall' || /metall|alu|edelstahl|stahl|messing|eloxi/.test(m)) return 'metal';
  return 'wood';
};
const API = process.env.REACT_APP_BACKEND_URL;
export const styleImage = src => src?.startsWith('/') ? `${API}${src}` : src;
export const styleGroup = editor => editor.textile ? 'textile' : metrics.crystal ? 'crystal' : 'engraving';
export const pickerItems = (kind, group) => kind === 'occasion' ? OCCASIONS : kind === 'style' ? STYLE_SETS[group] : PICKERS[kind];

export const GUIDE_STEPS = [['occasion', 'Anlass'], ['style', 'Stil'], ['motif', 'Motiv'], ['text', 'Text']];
export const REFINE_CHIPS = ['mehr Details', 'schlichter', 'andere Farben', 'ohne Hintergrund-Elemente', 'Schrift größer im Logo'];
